import { queryOptions } from "@tanstack/react-query";
import currency from "currency.js";

import { fetchCart } from "./requests";

export const CartQueries = {
  cart: (cartUuid: string) =>
    queryOptions({
      queryKey: ["cart", { cartUuid }],
      queryFn: () => fetchCart(cartUuid),
    }),
  cartTotal: (cartUuid: string) =>
    queryOptions({
      ...CartQueries.cart(cartUuid),
      select: (cart) => {
        const total = cart.items
          .map((item) =>
            currency(item.totalSalesPriceTaxInclusive).multiply(
              item.multiplier,
            ),
          )
          .reduce((a, b) => a.add(b), currency(0)).value;
        return total;
      },
    }),
};
